import { render, staticRenderFns } from "./TeachersEdit.vue?vue&type=template&id=11f68117"
import script from "./TeachersEdit.vue?vue&type=script&lang=js"
export * from "./TeachersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports